// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  workflow: require('./workflow.json'),
  reportPublishTime: '15:00:00', //Report auto publish at 3PM ET
  //local
  // apiEndpoint: 'http://localhost:58830/api',
  // tokenEndpoint: 'http://localhost:58830/token',
  // logoutUrl: 'https://www.cert.eauth.usda.gov/Logout/logoff.asp',
  // loginUrl: 'http://localhost:51274/LoginPage.aspx',
  // serverUrl: 'http://localhost:51274',
  // GAUrl: 'https://analytics.google.com/analytics/web/?pli=1#/p294743007/reports/reportinghub',
  // GAId: 'G-GE755X0254'

 //dev server
  // apiEndpoint: 'https://devapps.fas.usda.gov/newgainapi/api',
  // tokenEndpoint:'https://devapps.fas.usda.gov/newgainapi/token',
  // logoutUrl:'https://devapps.fas.usda.gov/newgain',
  // loginUrl:'https://devapps.fas.usda.gov/newgain/LoginPage.aspx',
  // serverUrl:'https://devapps.fas.usda.gov/newgain/',
  // GAUrl: 'https://analytics.google.com/analytics/web/?pli=1#/p294743007/reports/reportinghub',
  // GAId: 'G-GE755X0254'

 //staging server
  // apiEndpoint: 'https://stgapps.fas.usda.gov/newgainapi/api',
  // tokenEndpoint:'https://stgapps.fas.usda.gov/newgainapi/token',
  // logoutUrl:'https://stgapps.fas.usda.gov/newgain',
  // //loginUrl:'https://stgapps.fas.usda.gov/newgain/LoginPage.aspx',
  // // NewEauth LoginPage redirection
  // loginUrl:'https://www.cert.eauth.usda.gov/eauth/b/usda/login?TARGET=-SM-https://stgapps.fas.usda.gov/newgain/LoginPage.aspx ',
  // serverUrl:'https://stgapps.fas.usda.gov/newgain/',
  // GAUrl: 'https://analytics.google.com/analytics/web/?pli=1#/p295236668/reports/reportinghub',
  // GAId: 'G-ZJ5HDPLNTH'



  //prod server
   apiEndpoint: 'https://apps.fas.usda.gov/newgainapi/api',
   tokenEndpoint:'https://apps.fas.usda.gov/newgainapi/token',
   logoutUrl:'https://gain.fas.usda.gov/',
   loginUrl:'https://gain.fas.usda.gov/LoginPage.aspx',
   serverUrl:'https://gain.fas.usda.gov/',
   GAUrl: 'https://analytics.google.com/analytics/web/?pli=1#/p295178864/reports/reportinghub',
   GAId: 'G-NF0V16XF9E'
};
